import type { FieldMergeFunction } from '@apollo/client';

export const mergeSortedByPrimary = (
	primaryKey: string = 'primaryCda_V'
): FieldMergeFunction => {
	return (_existing, incoming = [], { readField }) => {
		return [...incoming].sort((a, b) => {
			const isAPrimary = readField<boolean>(primaryKey, a);
			const isBPrimary = readField<boolean>(primaryKey, b);

			if (isAPrimary === isBPrimary) return 0;

			return isAPrimary ? -1 : 1;
		});
	};
};
